import { FC } from "react";

import { PointShipmentHistory } from "@/features/PointShipmentHistory";
import { BaseModal } from "@/shared/ui/BaseModal";
import { PrimaryText } from "@/shared/ui/Typography";

import { ShipmentModalPayload } from "./ShipmentsModal.types";

interface ShipmentsModal extends ShipmentModalPayload {
    onClose: () => void;
}

export const ShipmentsModal: FC<ShipmentsModal> = ({
    pointId,
    pointName,
    targetDate,
    onClose,
}) => {
    return (
        <BaseModal
            open
            onClose={onClose}
            actions={null}
            mask={{ closable: true }}
            title={"Історія доставок"}
            styles={{
                container: { minHeight: "200px" },
            }}
        >
            <PrimaryText>{pointName}</PrimaryText>

            <PointShipmentHistory pointId={pointId} initialDate={targetDate} />
        </BaseModal>
    );
};
